/**
 * DominoSequence — renders a sequence of domino pieces.
 *
 * data: { dominos: [[3, 5], [2, 4], ["?", "?"]] }
 *
 * Each domino: [top, bottom] — number 0-9 or "?" for mystery.
 * Dots are rendered as pip patterns for 0-6, numbers for 7-9.
 */

const PIP_POSITIONS = {
    0: [],
    1: [[50, 50]],
    2: [[30, 30], [70, 70]],
    3: [[30, 30], [50, 50], [70, 70]],
    4: [[30, 30], [70, 30], [30, 70], [70, 70]],
    5: [[30, 30], [70, 30], [50, 50], [30, 70], [70, 70]],
    6: [[30, 25], [70, 25], [30, 50], [70, 50], [30, 75], [70, 75]],
};

function DominoHalf({ value }) {
    const isMystery = value === '?' || value === '?';
    const num = isMystery ? -1 : parseInt(value, 10);
    const pips = PIP_POSITIONS[num];

    if (isMystery) {
        return (
            <div className="qv-domino__half qv-domino__half--mystery">
                <span>?</span>
            </div>
        );
    }

    if (pips) {
        return (
            <div className="qv-domino__half">
                <svg viewBox="0 0 100 100" className="qv-domino__pips">
                    {pips.map(([cx, cy], i) => (
                        <circle key={i} cx={cx} cy={cy} r="10" />
                    ))}
                </svg>
            </div>
        );
    }

    // Numbers 7-9: show as text
    return (
        <div className="qv-domino__half">
            <span className="qv-domino__number">{num}</span>
        </div>
    );
}

export default function DominoSequence({ data }) {
    // Accept both { dominos: [[3,5],[2,4]] } and { domino: [3, 5] } for single
    const dominos = data?.dominos || (data?.domino ? [data.domino] : null);
    if (!Array.isArray(dominos) || dominos.length === 0) return null;

    return (
        <div className="qv-dominos">
            {dominos.map((d, i) => {
                const [top, bottom] = Array.isArray(d) ? d : [0, 0];
                const isMystery = top === '?' || bottom === '?';
                return (
                    <div key={i} className={`qv-domino ${isMystery ? 'qv-domino--mystery' : ''}`}>
                        <DominoHalf value={top} />
                        <div className="qv-domino__divider" />
                        <DominoHalf value={bottom} />
                    </div>
                );
            })}
        </div>
    );
}
